import { render, staticRenderFns } from "./gradientText.vue?vue&type=template&id=26168357&scoped=true"
import script from "./gradientText.vue?vue&type=script&lang=js"
export * from "./gradientText.vue?vue&type=script&lang=js"
import style0 from "./gradientText.vue?vue&type=style&index=0&id=26168357&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.12_css-loader@6.11.0_webpack@5.95.0__lodash@4.17.21__mu2kzy4yce77og2lygjn7k5jt4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26168357",
  null
  
)

export default component.exports